export const API_KEY =
  '953547866787-84l82sks23sj7mfgnqa79hkns4934ft8.apps.googleusercontent.com';
